import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { useAppContext } from '../../../../contexts/auth';
import { ErrorsInterface } from '../../../../hooks/useErrors';

interface UseSubmitInterface {
  setLogin: Dispatch<SetStateAction<string>>;
  setPassword: Dispatch<SetStateAction<string>>;
  removeError: (fieldName: string) => void;
  loginType: string;
  cpf: string;
  email: string;
  login: string;
  password: string;
  setLoginType: Dispatch<SetStateAction<string>>;
  setCpf: Dispatch<SetStateAction<string>>;
  setEmail: Dispatch<SetStateAction<string>>;
  errors: ErrorsInterface[];
}

export default function useSubmit({
  setLogin,
  setPassword,
  removeError,
  loginType,
  cpf,
  email,
  login,
  password,
  setLoginType,
  setCpf,
  setEmail,
  errors,
}: UseSubmitInterface) {
  const [isLoading, setIsLoading] = useState(false);

  const context = useAppContext();

  const checkIsValidLogin = useCallback(() => {
    if (!context.signed) {
      setLogin('');
      setEmail('');
      setCpf('');
      setPassword('');
      setIsLoading(false);
      removeError('cpf');
      removeError('email');
    }
  }, [context.signed, removeError, setCpf, setEmail, setLogin, setPassword]);

  async function handleLogin() {
    setIsLoading(true);
    const isLoginValidAndMadeWithUsername = await context.Login({
      loginType,
      login: cpf || email || login,
      password,
    });
    if (isLoginValidAndMadeWithUsername) {
      setLoginType('cpf');
      setLogin('');
      setCpf('');
      setEmail('');
      removeError('cpf');
      removeError('email');
    }
    // setIsLoading(false);
    checkIsValidLogin();
  }

  const isFormValid = errors.length === 0 && (cpf || email || login) && password;

  return {
    isLoading,
    handleLogin,
    isFormValid,
    context
  };
}
